import { stringify } from 'query-string';

import { BASE_URL_V3 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'MONTHLY_PROGRESS_GET',
  GET_SUCCESS: 'MONTHLY_PROGRESS_GET_SUCCESS',
  GET_FAILURE: 'MONTHLY_PROGRESS_GET_FAILURE',
};

export const get = actions.get(
  (studentId, query) => `${BASE_URL_V3}/mpr/${studentId}/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
